/* Mirevii theme logic – ported from the Lovable storefront (categories, colours, sizes, descriptions, cart). */
(function () {
  'use strict';
  var MV = window.MV = window.MV || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  MV.esc = esc;
  MV.money = function (cents) {
    var n = Number(cents) / 100;
    return new Intl.NumberFormat('nb-NO', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NOK', maximumFractionDigits: n % 1 === 0 ? 0 : 2 }).format(n);
  };
  var ICON = {
    x: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>', minus: '<path d="M5 12h14"/>', plus: '<path d="M5 12h14"/><path d="M12 5v14"/>',
    bag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    left: '<path d="m15 18-6-6 6-6"/>', right: '<path d="m9 18 6-6-6-6"/>', down: '<path d="m6 9 6 6 6-6"/>',
    zoom: '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/><path d="M11 8v6"/><path d="M8 11h6"/>',
    check: '<path d="M20 6 9 17l-5-5"/>', heart: '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>'
  };
  MV.icon = function (n, cls) { return '<svg class="icon ' + (cls || '') + '" viewBox="0 0 24 24" aria-hidden="true">' + ICON[n] + '</svg>'; };

  /* ---------- Categories (src/lib/categories.ts) ---------- */
  MV.CATEGORIES = [
    { slug: 'winter-collection-2026', label: 'Mirevii Winter Collection 2026', tagline: 'Strikk, yttertøy og støvler for vintergarderoben.', types: [] },
    { slug: 'jakker', label: 'Jakker', tagline: 'Tidløse lag', types: ['jakker', 'jakke'] },
    { slug: 'blazere', label: 'Blazere', tagline: 'Tidløse favoritter', types: ['blazere', 'blazer'] },
    { slug: 'strikk', label: 'Strikk', tagline: 'Myke klassikere', types: ['strikk', 'genser', 'gensere', 'cardigan', 'cardigans', 'strikktopp'] },
    { slug: 'kjoler', label: 'Kjoler', tagline: 'For enhver anledning', types: ['kjole', 'kjoler'] },
    { slug: 'bukser', label: 'Bukser og skjørt', tagline: 'Presise snitt', types: ['bukse', 'bukser', 'skjørt', 'shorts'] },
    { slug: 'yttertoy', label: 'Yttertøy', tagline: 'Lag på lag', types: ['yttertøy', 'kåpe', 'kåper', 'frakk', 'frakker'] },
    { slug: 'tilbehor', label: 'Vesker og tilbehør', tagline: 'Den siste detaljen', types: ['tilbehør', 'veske', 'vesker', 'håndveske', 'halskjede', 'smykker', 'sokker', 'strømper', 'belte', 'skjerf', 'lue'] },
    { slug: 'sko', label: 'Sko', tagline: 'For hvert steg', types: ['sko', 'støvletter', 'støvlett', 'ankelstøvletter', 'ankelstøvler', 'støvler', 'boots', 'sneakers', 'vinterstøvler / snøstøvler', 'tøfler', 'sandaler'] },
    { slug: 'topper', label: 'Topper og bluser', tagline: 'Garderobens favoritter', types: ['topp', 'topper', 'bluse', 'bluser', 'skjorte', 'skjorter', 't-skjorte'] },
    { slug: 'sett', label: 'Matchende sett', tagline: 'En helhetlig stil', types: ['sett', 'matchende sett', 'co-ord', 'co-ords'] },
    { slug: 'undertoy', label: 'Undertøy', tagline: 'Nærmest deg', types: ['undertøy', 'undertøyssett', 'undertøysett', 'bh-sett', 'bh og truse-sett', 'bh', 'truse', 'body', 'lingerie'] },
    { slug: 'lingerie', label: 'Lingerie', tagline: 'Fine detaljer', types: ['lingerie'] },
    { slug: 'nattoy', label: 'Loungewear og nattøy', tagline: 'Rolige øyeblikk', types: ['nattøy', 'nattkjole', 'loungewear-sett', 'loungewear', 'pysjamas', 'morgenkåpe'] }
  ];
  var norm = function (v) { return String(v || '').trim().toLocaleLowerCase('nb-NO'); };
  MV.productCategory = function (p) {
    var type = norm(p.type), title = norm(p.title);
    if (type === 'loungewear-sett' && /blondesett|korsettsett/.test(title)) return 'lingerie';
    var c = MV.CATEGORIES.filter(function (c) { return c.types.indexOf(type) >= 0; })[0];
    var slug = c && c.slug;
    if (slug === 'undertoy' && /blonde|korsett|brodert|broderi|bralette/.test(title)) return 'lingerie';
    if (slug === 'topper' && /strikk/.test(title)) return 'strikk';
    return slug;
  };
  MV.productMatchesCategory = function (p, slug) {
    var primary = MV.productCategory(p);
    if (slug === 'winter-collection-2026') {
      if (primary === 'strikk' || primary === 'yttertoy') return true;
      var title = norm(p.title), type = norm(p.type);
      if (primary === 'jakker') return !/denim|jeans|lett jakke|sommer/.test(title);
      if (primary === 'sko') return /støv|boots|snø/.test(type + ' ' + title);
      if (primary === 'tilbehor') return /skjerf|lue|hanske|vott/.test(type + ' ' + title);
      return false;
    }
    if (slug === 'undertoy') return primary === 'undertoy' || primary === 'lingerie';
    if (slug === 'yttertoy') return primary === 'yttertoy' || primary === 'jakker' || primary === 'blazere';
    return primary === slug;
  };

  MV.categoryHasProducts = function (products, slug) {
    return products.some(function (p) { return p.available && MV.productMatchesCategory(p, slug); });
  };
  MV.newestRelated = function (products, currentHandle) {
    return products.filter(function (p) { return p.handle !== currentHandle; })
      .sort(function (a, b) { return (b.created || '').localeCompare(a.created || ''); }).slice(0, 4);
  };
  var catalogPromise;
  MV.loadCatalog = function (initial) {
    if (catalogPromise) return catalogPromise;
    function next(data) {
      if (!data.next) return Promise.resolve(data.products);
      return fetch('/collections/all?view=mirevii-catalog&page=' + data.next)
        .then(function (r) { if (!r.ok) throw new Error('Catalog unavailable'); return r.json(); })
        .then(next).then(function (products) { return data.products.concat(products); });
    }
    catalogPromise = next(initial);
    return catalogPromise;
  };

  /* ---------- Sizes (src/lib/product-sizes.ts) ---------- */
  MV.SIZE_RE = /størrelse|storrelse|storlek|size/i;
  MV.COLOR_RE = /farge|color|colour/i;
  var letterRanks = { XXS: -2, XS: -1, S: 0, M: 1, L: 2, XL: 3 };
  function sizeKey(value) {
    var n = String(value).trim().toUpperCase().replace(/,/g, '.');
    if (/^(ONE\s*SIZE|ONESIZE|FREE\s*SIZE|OS|EN\s*STØRRELSE)$/.test(n)) return [2];
    var w = n.match(/^(SMALL|MEDIUM|LARGE)(?=$|[\s(])/);
    if (w) return [0, w[1] === 'SMALL' ? 0 : w[1] === 'MEDIUM' ? 1 : 2];
    var l = n.match(/^(XXS|XS|S|M|L|XL|X{2,}S|X{2,}L|\d+X[LS])(?=$|[\s/(-])/);
    if (l) {
      var label = l[1], r = letterRanks[label];
      if (r !== undefined) return [0, r];
      var count = label.charAt(0) === 'X' ? label.length - 1 : parseInt(label, 10);
      return [0, /S$/.test(label) ? -count : count + 2];
    }
    var num = n.match(/^(?:(?:EU|EUR|US|UK)\s*)?(\d+(?:\.\d+)?)(.*)$/);
    if (num) {
      var cupM = (num[2] || '').trim().replace(/^[°–—-]\s*/, '').match(/^([A-K]+)$/);
      var cup = cupM && cupM[1];
      return [1, Number(num[1]), cup ? cup.charCodeAt(0) : 0, cup ? cup.length : 0];
    }
    return null;
  }
  MV.compareSizes = function (a, b) {
    var x = sizeKey(a), y = sizeKey(b);
    if (!x || !y) return x ? -1 : y ? 1 : 0;
    for (var i = 0; i < Math.max(x.length, y.length); i++) { var d = (x[i] || 0) - (y[i] || 0); if (d) return d; }
    return 0;
  };
  MV.sortSizes = function (v) { return v.slice().sort(MV.compareSizes); };

  /* ---------- Colour swatches (src/lib/product-colors.ts) ---------- */
  var ALIASES = {
    'onyx': 'black', 'onyks': 'black', 'nattsort': 'black', 'nattsvart': 'black', 'dyp sort': 'black', 'kullsort': 'black', 'ibenholt': 'black', 'ravnsort': 'black', 'helsort': 'black', 'sort med varmt fôr': 'black',
    'rubin': 'red', 'rubinrød': 'red', 'dyp rubin': 'red', 'dyp rød': 'red', 'teglrød': 'orange',
    'nattblå': 'navy', 'midnattsblå': 'navy', 'dyp marine': 'navy',
    'isblå': 'light-blue', 'lys isblå': 'light-blue', 'dueblå': 'light-blue', 'dueblå grå': 'light-blue', 'duebla': 'light-blue', 'støvblå': 'light-blue', 'duegrå': 'grey', 'askegrå': 'grey', 'gråmelert': 'grey', 'sølvfrost': 'grey', 'skifergrå': 'charcoal', 'grafitt': 'charcoal', 'koksgrå melert': 'charcoal', 'blågrå': 'grey',
    'koboltblå': 'blue', 'denimblå': 'blue', 'havblå': 'blue', 'fjordblå': 'blue', 'turkis': 'teal', 'dyp petrol': 'teal',
    'rosé': 'pink', 'lys rosé': 'pink', 'rosa blush': 'pink', 'lys pudder': 'pink', 'korall': 'coral', 'fuksiarosa': 'fuchsia',
    'skogsgrønn': 'forest', 'skoggrønn': 'forest', 'mosegrønn': 'olive', 'lys salvie': 'sage', 'salviegrå': 'sage',
    'plomme': 'plum', 'dyp plomme': 'plum', 'aprikos': 'apricot', 'aprikos beige': 'apricot', 'aprikoskrem': 'apricot',
    'snøhvit': 'white', 'kritthvit': 'white', 'krithvit': 'white', 'krittfarget': 'white', 'krittfarget hvit': 'white', 'kremhvit': 'ivory', 'vanilje': 'ivory',
    'havre': 'sand', 'sandbeige': 'sand', 'lys sand': 'sand', 'varm sand': 'sand', 'naturmelert': 'sand',
    'mørk mokka': 'brown', 'mørk sjokolade': 'brown', 'kastanjebrun': 'brown', 'kastanje': 'brown', 'kanel': 'tan', 'kakao': 'brown', 'kaffebrun': 'brown', 'oppgradert kaffebrun': 'brown', 'mokkabrun': 'taupe',
    'kamel': 'tan', 'varm khaki': 'tan', 'oppgradert khaki': 'tan', 'mørk konjakk': 'brown', 'varm konjakk': 'tan', 'konjakkbrun': 'tan',
    'mandarin': 'orange', 'terrakotta': 'orange', 'smørgul': 'pale-yellow', 'oker': 'gold', 'gyllen': 'gold'
  };
  var GROUPS = [
    ['black', /^(sort|svart|black|noir)$/], ['white', /^(hvit|white|blanc)$/], ['ivory', /^(elfenben|ivory|perlehvit|krem|cream|off[ -]?white|ecru)$/],
    ['sand', /^(beige|sand|nude|champagne|lys beige)$/], ['taupe', /^(taupe|greige|mokka|mocha)$/], ['brown', /^(brun|brown|sjokolade|chocolate|mørkebrun|mørk brun|kaffe)$/],
    ['tan', /^(camel|karamell|cognac|konjakk|lysebrun|lys brun|khaki)$/], ['grey', /^(grå|gra|grey|gray|sølv|silver|lysegrå|lys grå)$/], ['charcoal', /^(mørkegrå|mørk grå|koksgrå|antrasitt|charcoal)$/],
    ['navy', /^(marine|marineblå|navy|mørkeblå|mørk blå)$/], ['blue', /^(blå|blue|denim|kongeblå)$/], ['light-blue', /^(lyseblå|lys blå|himmelblå|light blue)$/],
    ['green', /^(grønn|green|smaragd|smaragdgrønn)$/], ['olive', /^(oliven|olivengrønn|armygrønn|olive)$/], ['sage', /^(salvie|salviegrønn|mint|mintgrønn|sage)$/],
    ['red', /^(rød|red|rouge)$/], ['burgundy', /^(vinrød|burgunder|bordeaux|burgundy)$/], ['pink', /^(rosa|pink|pudderrosa|støvrosa|lyserosa|lys rosa|blush)$/],
    ['fuchsia', /^(fuksia|fuchsia|hot pink|mørkerosa)$/], ['purple', /^(lilla|purple|fiolett)$/], ['lilac', /^(lavendel|syrin|lilac|lys lilla)$/],
    ['yellow', /^(gul|yellow)$/], ['gold', /^(gull|gold|sennep|sennepsgul)$/], ['orange', /^(oransje|orange|rust|rustbrun|terracotta)$/]
  ];
  MV.colorSwatch = function (color) {
    var v = String(color).normalize('NFKC').toLocaleLowerCase('nb-NO').trim().replace(/^3-pakning,\s*/, '')
      .replace(/(?:\s*[–,].*|\s+(?:premium|ada|juni|bea|iris|eli)(?:,.*)?|\s+med (?:varmt fôr|hvit såle))$/, '');
    if (ALIASES[v]) return ALIASES[v];
    for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i][1].test(v)) return GROUPS[i][0];
    return null;
  };

  /* ---------- Colour → image (src/lib/product-color-image.ts) ---------- */
  var CORRECTED = { Elfenben: '03_elara_black_studio.jpg', Taupe: '01_elara_ivory_studio.jpg', Svart: '02_elara_taupe_studio.jpg' };
  var reEsc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
  MV.productColorImage = function (images, color, variants, colors) {
    colors = colors || [];
    var verified = images.filter(function (i) { return i.alt === 'Mirevii verified colour: ' + color; })[0];
    if (verified) return verified;
    if (images.some(function (i) { return i.url.indexOf('01_elara_ivory_studio.jpg') >= 0; })) {
      var file = CORRECTED[color];
      if (file) return images.filter(function (i) { return i.url.indexOf(file) >= 0; })[0] || null;
    }
    if (['Blå', 'Lys blå', 'Mørk blå'].indexOf(color) >= 0 && images.some(function (i) { return i.url.indexOf('mirevii-11345810522455-') >= 0; })) return null;
    var match = new RegExp('(^|[^\\p{L}])' + reEsc(color) + '([^\\p{L}]|$)', 'iu');
    var matches = function (im) {
      return Boolean(im.alt && match.test(im.alt) && !colors.some(function (other) {
        if (other.length <= color.length || other.toLowerCase().indexOf(color.toLowerCase()) < 0) return false;
        return new RegExp('(^|[^\\p{L}])' + reEsc(other) + '([^\\p{L}]|$)', 'iu').test(im.alt || '');
      }));
    };
    var explicit = images.filter(matches)[0];
    if (explicit) return explicit;
    var fb = null;
    variants.some(function (v) { if (v.image && v.colorValue === color) { fb = v.image; return true; } return false; });
    if (!fb) return null;
    var alt = (fb.alt || '').trim();
    return !alt || matches(fb) ? fb : null;
  };

  /* ---------- Description split (src/lib/product-description.ts) ---------- */
  var materialLabel = /^(?:materiale(?:r)?|materials?|overmateriale|f[oóô]r|innersåle|yttersåle)\s*:/i;
  var careLabel = /^(?:vedlikehold|pleie|care|vaskeanvisning)\s*:/i;
  var sectionLabel = /^(?:materiale(?:r)?|materials?|vedlikehold|pleie|care|materialer?\s*(?:&|og)\s*vedlikehold)\s*:?$/i;
  var careInstruction = /^(?:følg vaskeanvisningen|tørk forsiktig|impregner før bruk|merk:.*(?:impregnering|børste|tørke))/i;
  MV.splitDescription = function (html) {
    var doc = new DOMParser().parseFromString('<div>' + (html || '') + '</div>', 'text/html');
    function split(nodes, initial) {
      var res = { description: [], materialsCare: [] }, section = initial;
      nodes.forEach(function (node) {
        if (node.nodeType !== 1) { res[section].push(node); return; }
        var name = node.nodeName.toLowerCase();
        var text = node.textContent.replace(/\s+/g, ' ').trim();
        if (!text && (name === 'p' || name === 'br')) return;
        var heading = /^h[1-6]$/.test(name) || (name === 'p' && sectionLabel.test(text));
        if (heading) { section = sectionLabel.test(text) ? 'materialsCare' : 'description'; res[section].push(node); }
        else if (['div', 'section', 'article', 'ul', 'ol'].indexOf(name) >= 0) {
          var ch = split(Array.prototype.slice.call(node.childNodes), section);
          ['description', 'materialsCare'].forEach(function (t) {
            if (ch[t].some(function (c) { return c.textContent.trim(); })) {
              var w = node.cloneNode(false); ch[t].forEach(function (c) { w.appendChild(c.cloneNode(true)); }); res[t].push(w);
            }
          });
        } else {
          res[materialLabel.test(text) || careLabel.test(text) || careInstruction.test(text) ? 'materialsCare' : section].push(node);
        }
      });
      return res;
    }
    var s = split(Array.prototype.slice.call(doc.body.firstChild.childNodes), 'description');
    var out = function (list) { var d = document.createElement('div'); list.forEach(function (n) { d.appendChild(n.cloneNode(true)); }); return d.innerHTML.trim(); };
    return { description: out(s.description), materialsCare: out(s.materialsCare) };
  };

  /* ---------- Size guide tab ---------- */
  MV.sizeGuideTab = function (sizes) {
    if (sizes.some(function (s) { return /^\s*(EU\s*)?(3[3-9]|4[0-6])(\.5)?\s*$/i.test(s); })) return 'sko';
    if (sizes.some(function (s) { return /^\s*(6[5-9]|[7-9]\d|1[01]\d)\s*[A-H]{1,2}\s*$/i.test(s); })) return 'bh';
    return 'klaer';
  };
  MV.openSizeGuide = function (tab) {
    var d = $('#size-guide'); if (!d) return;
    selectTab(d, tab || 'klaer'); d.showModal();
  };
  function selectTab(d, tab) {
    $$('[role=tab]', d).forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.tab === tab)); });
    $$('[role=tabpanel]', d).forEach(function (p) { p.hidden = p.dataset.tab !== tab; });
  }

  /* ---------- Product card ---------- */
  MV.card = function (p) {
    var img = p.images[0], img2 = p.images[1] || img;
    var media = img ? '<img class="main" src="' + esc(img.url) + '" alt="' + esc(img.alt || p.title) + '" loading="lazy"><img class="alt" src="' + esc(img2.url) + '" alt="" aria-hidden="true" loading="lazy">' : '<div class="noimg eyebrow">Bilde kommer</div>';
    return '<a class="product-card" href="/products/' + esc(p.handle) + '"><div class="card-media">' + media + (p.available === false ? '<span class="card-badge eyebrow">Utsolgt</span>' : '') + '</div><div class="card-meta"><h3 class="card-title">' + esc(p.title) + '</h3><p class="card-price">' + MV.money(p.price) + '</p>' + (p.colorCount > 1 ? '<p class="card-colors">' + p.colorCount + ' farger</p>' : '') + '</div></a>';
  };

  /* ---------- Sheets ---------- */
  function openSheet(id) { var s = document.getElementById(id); if (!s) return; s.classList.add('sheet-open'); document.body.style.overflow = 'hidden'; }
  function closeSheet(id) { var s = document.getElementById(id); if (!s) return; s.classList.remove('sheet-open'); document.body.style.overflow = ''; }
  MV.openSheet = openSheet; MV.closeSheet = closeSheet;
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-sheet]'); if (t) { e.preventDefault(); openSheet(t.dataset.openSheet); if (t.dataset.openSheet === 'cart-sheet') MV.renderCart(); }
    var c = e.target.closest('[data-close-sheet]'); if (c) { closeSheet(c.dataset.closeSheet); }
    var sg = e.target.closest('[data-size-guide]'); if (sg) { e.preventDefault(); MV.openSizeGuide(sg.dataset.sizeGuide); }
    var tb = e.target.closest('#size-guide [role=tab]'); if (tb) selectTab($('#size-guide'), tb.dataset.tab);
    var dc = e.target.closest('[data-close-dialog]'); if (dc) dc.closest('dialog').close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSheet('menu-sheet'); closeSheet('cart-sheet'); var hs = $('#header-search'); if (hs) hs.hidden = true; } });
  $$('dialog.mv-dialog').forEach(function (d) { d.addEventListener('click', function (e) { if (e.target === d) d.close(); }); });

  MV.toast = function (msg) {
    var t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 2500);
  };

  /* ---------- Cart (Ajax Cart API) ---------- */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function cartFetch(path, body) {
    return fetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || r.status); }); return r.json(); });
  }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }
  MV.addToCart = function (variantId, qty) {
    return cartFetch('cart/add.js', { items: [{ id: variantId, quantity: qty || 1 }] }).then(function () { return MV.renderCart(); }).then(function () { openSheet('cart-sheet'); });
  };
  MV.renderCart = function () {
    var box = $('#cart-sheet-body');
    return cartFetch('cart.js').then(function (cart) {
      setCount(cart.item_count);
      var desc = $('#cart-sheet-desc'); if (desc) desc.textContent = cart.item_count === 0 ? 'Handlekurven er tom' : cart.item_count + ' ' + (cart.item_count === 1 ? 'vare' : 'varer');
      $$('[data-cart-render]').forEach(function (b) { b.innerHTML = cartHtml(cart, b.dataset.cartRender === 'page'); });
      return cart;
    });
  };
  function cartHtml(cart, page) {
    if (!cart.items.length) return '<div class="cart-empty">' + MV.icon('bag') + '<p class="muted" style="font-size:.875rem">Du har ikke lagt til noe ennå.</p><a class="btn-outline" href="/collections/all">Utforsk kolleksjonen</a></div>';
    var lines = cart.items.map(function (it, i) {
      var opts = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="muted" style="margin-top:.25rem;font-size:.75rem">' + esc((it.options_with_values || []).map(function (o) { return o.value; }).join(' · ')) + '</p>' : '';
      return '<li class="cart-line" data-line="' + (i + 1) + '"><div class="cart-line-img">' + (it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '">' : '') + '</div><div class="cart-line-body"><div class="cart-line-top"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><button class="btn-icon muted" data-qty="0" aria-label="Fjern vare">' + MV.icon('x', 'icon-sm') + '</button></div>' + opts +
        '<div class="cart-line-bottom"><div class="qty"><button data-qty="' + (it.quantity - 1) + '" aria-label="Færre">' + MV.icon('minus', 'icon-xs') + '</button><span>' + it.quantity + '</span><button data-qty="' + (it.quantity + 1) + '" aria-label="Flere">' + MV.icon('plus', 'icon-xs') + '</button></div><span style="font-size:.875rem">' + MV.money(it.final_line_price) + '</span></div></div></li>';
    }).join('');
    return '<ul class="cart-lines">' + lines + '</ul><div class="cart-foot"><div class="row"><span class="eyebrow">Delsum</span><span class="total">' + MV.money(cart.total_price) + '</span></div>' +
      (cart.total_discount ? '<p class="muted" style="font-size:.75rem">Rabatt: −' + MV.money(cart.total_discount) + '</p>' : '') +
      '<p class="muted" style="font-size:.75rem">Frakt og eventuelle avgifter beregnes i kassen.</p><a class="btn-luxe" style="width:100%" href="/checkout">Gå til kassen</a></div>';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-render] [data-qty]'); if (!b) return;
    var wrap = b.closest('[data-cart-render]'); wrap.classList.add('is-busy');
    cartFetch('cart/change.js', { line: Number(b.closest('[data-line]').dataset.line), quantity: Math.max(0, Number(b.dataset.qty)) })
      .then(MV.renderCart).catch(function () { MV.toast('Kunne ikke oppdatere handlekurven.'); }).then(function () { wrap.classList.remove('is-busy'); });
  });

  /* ---------- Header search + predictive ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = $('[data-search-toggle]'), box = $('#header-search');
    if (toggle && box) {
      toggle.addEventListener('click', function () { box.hidden = !box.hidden; if (!box.hidden) $('input', box).focus(); });
      var input = $('input', box), out = $('#predictive', box), timer;
      input.addEventListener('input', function () {
        clearTimeout(timer); var q = input.value.trim();
        if (q.length < 2) { out.innerHTML = ''; return; }
        timer = setTimeout(function () {
          fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6').then(function (r) { return r.json(); }).then(function (j) {
            var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
            out.innerHTML = ps.map(function (p) { return '<a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') + '<span><span class="font-display">' + esc(p.title) + '</span><br><span class="muted" style="font-size:.75rem">' + esc(p.price) + ' kr</span></span></a>'; }).join('');
          }).catch(function () { out.innerHTML = ''; });
        }, 200);
      });
    }
    MV.renderCart().catch(function () {});
    var catalog = $('[data-home-catalog]');
    if (catalog) {
      var initial = JSON.parse(catalog.textContent);
      function updateCategories(products) {
        $$('[data-category-slug]').forEach(function (tile) {
          var available = MV.categoryHasProducts(products, tile.dataset.categorySlug);
          $('[data-category-empty]', tile).hidden = available;
          var cta = $('.cta', tile); if (cta) cta.hidden = !available;
        });
      }
      updateCategories(initial.products);
      MV.loadCatalog(initial).then(updateCategories).catch(function () {});
    }
    $$('[data-carousel]').forEach(function (c) {
      var track = $('.carousel-track', c);
      $$('[data-dir]', c).forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * 0.8, behavior: 'smooth' }); }); });
    });
  });
})();

/* Färgbyte: skrolla upp till produktbilden om den är utanför synfältet (främst mobil) */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.swatch-btn[aria-label^="Farge"]');
    if (!btn) return;
    setTimeout(function () {
      var gallery = document.querySelector('.product-gallery');
      if (!gallery) return;
      var header = document.getElementById('shopify-section-header');
      var offset = header ? header.getBoundingClientRect().height : 0;
      var top = gallery.getBoundingClientRect().top;
      if (top < offset) {
        window.scrollTo({ top: top + window.pageYOffset - offset - 8, behavior: 'smooth' });
      }
    }, 50);
  });
})();